import React, { useContext, useEffect, useState } from 'react';
import './Preparing.css';

import { HybirdContext, withDeepLink } from './containers/HybirdContext.container';
import { Loading } from './Loading';

const cdn = 'https://static.shanghaidisneyresort.com';
const HeaderCN = cdn + '/1c6d85747f191131/media/aa4341f54253c579/header_cn.png';
const Body1CN = cdn + '/1c6d85747f191131/media/c6521cd03035918a/body1_cn.png';
const Body2CN = cdn + '/1c6d85747f191131/media/653ce9f874174420/body2_cn.png';
const Body3CN = cdn + '/1c6d85747f191131/media/378943bb16e32688/body3_cn.png';
const FooterCN = cdn + '/1c6d85747f191131/media/3d75cd10f34ba7b6/footer_cn.png';
const Header = cdn + '/1c6d85747f191131/media/e646433f4b675c36/header.png';
const Body1 = cdn + '/1c6d85747f191131/media/b6e62f8c9ee800db/body1.png';
const Body2 = cdn + '/1c6d85747f191131/media/7ec36979d2e841e4/body2.png';
const Body3 = cdn + '/1c6d85747f191131/media/c0562345869f6ce2/body3.png';
const Footer = cdn + '/1c6d85747f191131/media/89d382c51276c7e3/footer.png';
function Preparing({onDeepLink}) {
  const hybirdContext = useContext(HybirdContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [language, setLanguage] = useState('')
  useEffect(() => {
    const fetchLang = async () => {
      try {
        const _language = await hybirdContext.getLanguage();

        setLanguage(_language);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        setError(true);
      }
    };

    fetchLang();
  }, [hybirdContext]);
  const onClickFooter = () => {
    onDeepLink && onDeepLink('wdpr-shdr://buytickets');
  };
  return loading ? (
    <div className="app-loading">
      <div className="loader-overlay">
        <Loading/>
      </div>
    </div>
  ) : (
    <div className='preparing-root-container'>
      <img src={language === 'en' ? Header : HeaderCN}/>
      <img src={language === 'en' ? Body1 : Body1CN}/>
      <img src={language === 'en' ? Body2 : Body2CN}/>
      <img src={language === 'en' ? Body3 : Body3CN}/>
      <img src={language === 'en' ? Footer : FooterCN} onClick={onClickFooter}/>
    </div>
  );
}

export default withDeepLink(Preparing);
